import { createFilter, createSorter } from 'components/Tables/ColumnCreationHelper';
import { t } from 'i18next';
import { AppTableFilters } from 'services/AppTableFilters';
import { IUserDiagnostic, UserDiagnosticsState, UserDiagnosticsTag } from 'types/models/UserDiagnosticsModel';
import { filterHasUserDiagnosticState, filterHasUserDiagnosticTags, getEnumFilterOptions } from 'utilities/FilterUtils';

export const appTableFiltersInstance = new AppTableFilters();

export const userDiagnosticsTableColumns = () => [
    {
        id: 'state',
        Header: t('UserDiagnostics.Column.State'),
        accessor: 'state',
        maxWidth: 30,
        sorter: createSorter(appTableFiltersInstance, 'state', 'number'),
        filter: createFilter(
            appTableFiltersInstance,
            'select',
            "state",
            t('UserDiagnostics.Column.State'),
            getEnumFilterOptions(UserDiagnosticsState),
            (item: IUserDiagnostic, value: string) => filterHasUserDiagnosticState(value, item.state)),
    },
    {
        id: 'userDiagnosticId',
        Header: t('UserDiagnostics.Column.Id'),
        accessor: 'id',
        maxWidth: 80,
        filter: createFilter(
            appTableFiltersInstance,
            'textfields',
            "id",
            t('UserDiagnostics.Column.Id'),
        )
    },
    {
        id: 'organizationName',
        Header: t('organizationName'),
        accessor: 'organizationName',
        maxWidth: 70,
        sorter: createSorter(appTableFiltersInstance, 'organizationName', 'text'),
        filter: createFilter(
            appTableFiltersInstance,
            'textfields',
            "organizationName",
            t('organizationName'),
        )
    },
    {
        id: 'operatorEmail',
        Header: t('UserDiagnostics.Column.OperatorEmail'),
        accessor: 'operatorEmail',
        maxWidth: 70,
        sorter: createSorter(appTableFiltersInstance, 'operatorEmail', 'text'),
        filter: createFilter(
            appTableFiltersInstance,
            'textfields',
            "operatorEmail",
            t('UserDiagnostics.Column.OperatorEmail'),
        )
    },
    {
        id: 'tag',
        Header: t('UserDiagnostics.Column.Tags'),
        accessor: 'userDiagnosticsTags',
        maxWidth: 40,
        sorter: createSorter(appTableFiltersInstance, 'tag', 'number'),
        filter: createFilter(
            appTableFiltersInstance,
            'multioption',
            "tag",
            t('UserDiagnostics.Column.Tags'),
            getEnumFilterOptions(UserDiagnosticsTag),
            (item: IUserDiagnostic, value: string[]) => {
                console.log(`valeu: ${value}`)
                return filterHasUserDiagnosticTags(value, item.userDiagnosticsTags)
            }),
    },
    {
        id: 'userSubject',
        Header: t('UserDiagnostics.Column.Subject'),
        accessor: 'userSubject',
        maxWidth: 80,
        filter: createFilter(
            appTableFiltersInstance,
            'textfields',
            "userSubject",
            t('UserDiagnostics.Column.Subject'),
        )
    },
    {
        id: 'addedAtUtc',
        Header: t('UserDiagnostics.Column.AddedAt'),
        accessor: 'addedAtUtc',
        maxWidth: 60,
        sorter: createSorter(appTableFiltersInstance, 'addedAtUtc', 'date'),
        filter: createFilter(
            appTableFiltersInstance,
            'textfields',
            "addedAtUtc",
            t('UserDiagnostics.Column.AddedAt'),
        )
    },
    {
        id: 'actions',
        Header: t('actions'),
        maxWidth: 80,
    },
];
